import styles from "@/styles/detail/DetailBookingSidebar/Sidebar.module.scss";
import { SlotsReadableTO } from "@/models/detail";
import { ETourLanguage, ETypePackage } from "@/models/common/enums";
import DetailBookingConfigurator from "./DetailBookingConfigurator";

const Sidebar = ({
    tourId,
    isPremium,
    setIsPremium,
    slots,
    days,
    typePackage,
    pricePremium,
    priceQuality,
    slotsPremium,
    slotsQuality,
    languages,
}: {
    tourId: string;
    setIsPremium: (el: boolean) => void;
    isPremium: boolean;
    slots: SlotsReadableTO[];
    days: string;
    typePackage: ETypePackage;
    priceQuality: number;
    pricePremium: number;
    slotsPremium: SlotsReadableTO[];
    slotsQuality: SlotsReadableTO[];
    languages: ETourLanguage[];
}) => {
    return (
        <div className={styles.container}>
            <DetailBookingConfigurator
                tourId={tourId}
                isPremium={isPremium}
                setIsPremium={setIsPremium}
                slots={slots}
                days={days}
                typePackage={typePackage}
                pricePremium={pricePremium}
                priceQuality={priceQuality}
                slotsPremium={slotsPremium}
                slotsQuality={slotsQuality}
                languages={languages}
            />
        </div>
    );
};

export default Sidebar;
